import { ADD_TICKET, UPDATE_TICKET} from './callCenter.actionsTypes';

export default function orders(state = [], action) {
	let newState = Object.assign([], state);
	switch (action.type) {
		case ADD_TICKET:
		case UPDATE_TICKET:
		default:
			return newState;
	}
}
